// src/pages/AdmissionPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Grid,
  TextField,
  MenuItem,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import BASE_URL from "../config";
export default function AdmissionPage() {
  const navigate = useNavigate();
  const storedName = sessionStorage.getItem("adminName");
  // Form state
  const [activeTab, setActiveTab] = useState("mandatory");
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [errors, setErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [studentData, setStudentData] = useState({
    studentName: "",
    mobileNumber: "",
    academicYearID: "",
    courseID: "",
    classID: "",
    address: "",
    parentName: "",
    parentContact: "",
    CreatedBy: storedName || "",
    CreatedDate: new Date().toISOString().split("T")[0],
    Section:"",
  });
  // Bulk upload result
  const [bulkResult, setBulkResult] = useState(null);
  // Fetch courses
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/coursesa`)
      .then((res) => setCourses(res.data))
      .catch((e) => console.error("Error fetching courses:", e));
  }, []);
  // Handlers
  const validateField = (name, value) => {
    let err = "";
    if (["studentName", "parentName"].includes(name)) {
      if (!/^[A-Za-z ]+$/.test(value)) err = "Only alphabets allowed";
    }
    if (["mobileNumber", "parentContact"].includes(name)) {
      if (!/^[0-9]{10}$/.test(value)) err = "Enter a valid 10-digit number";
    }
    setErrors((prev) => ({ ...prev, [name]: err }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudentData((pd) => ({ ...pd, [name]: value }));
    validateField(name, value);
     if (name === 'classID') {
    axios
      .get(`${BASE_URL}/api/sections/${value}`)
      .then((r) => setSections(r.data))
      .catch((e) => console.error('Error fetching sections', e));
  }
  };
  const handleCourseChange = (e) => {
    const courseID = e.target.value;
    setStudentData((pd) => ({
      ...pd,
      courseID,
      academicYearID: "",
      classID: "",
      Section:"",
    }));
    // fetch classes & years
    axios
      .get(`${BASE_URL}/api/academicYears/${courseID}`)
      .then((r) => setAcademicYears(r.data))
      .catch((e) => console.error(e));
    axios
      .get(`${BASE_URL}/api/classes?course=${courseID}`)
      .then((r) => setClasses(r.data))
      .catch((e) => console.error(e));
      
  };
  const handleSubmit = () => {
    // validate required
    const required = [
      "studentName",
      "mobileNumber",
      "courseID",
      "academicYearID",
      "classID",
    ];
    const newErr = {};
    let ok = true;
    required.forEach((f) => {
      if (!studentData[f]) {
        newErr[f] = "Required";
        ok = false;
      }
    });
    setErrors(newErr);
    if (!ok) return;
    const payload = Object.fromEntries(
      Object.entries(studentData).filter(([_, v]) => v !== "")
    );
    axios
      .post(`${BASE_URL}/api/admission`, payload)
      .then(() => {
        alert("Admission Successful!");
        // SMS
        axios.post(`${BASE_URL}/sms/send-message`, {
          mobile_no: payload.mobileNumber,
          parent_mobile:payload.parentContact || null,
          //message: `Hi ${payload.studentName}, your admission was successful!`,
          student_name: payload.studentName
        });
        navigate("/students");
      })
      .catch((e) => {
        console.error(e);
        alert("Error saving admission");
      });
  };
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    form.append("courseID", studentData.courseID);
    form.append("academicYearID", studentData.academicYearID);
    form.append("classID", studentData.classID);
     form.append("Section", studentData.Section);
    form.append("CreatedBy", sessionStorage.getItem("santosh") || "bulk-upload");
    try {
      const res = await axios.post(
        `${BASE_URL}/api/admission/bulk`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setBulkResult(res.data);
    } catch (err) {
      console.error(err);
      alert("Bulk upload failed");
    }
  };
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#1976d2", textTransform: "uppercase" }}
      >
        Student Admission
      </Typography>
      {/* --- Bulk Upload Section --- */}
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Bulk Admission via Excel
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <InputLabel>Course</InputLabel>
                <Select
                  name="courseID"
                  value={studentData.courseID}
                  onChange={handleCourseChange}
                >
                  <MenuItem value="">-- Select --</MenuItem>
                  {courses.map((c) => (
                    <MenuItem key={c.CourseID} value={c.CourseID}>
                      {c.CourseName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <InputLabel>Academic Year</InputLabel>
                <Select
                  name="academicYearID"
                  value={studentData.academicYearID}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">-- Select --</MenuItem>
                  {academicYears.map((y) => (
                    <MenuItem key={y.AcademicYearID} value={y.AcademicYearID}>
                      {y.AcademicYearName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <InputLabel>Class</InputLabel>
                <Select
                  name="classID"
                  value={studentData.classID}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">-- Select --</MenuItem>
                  {classes.map((cls) => (
                    <MenuItem key={cls.id} value={cls.id}>
                      {cls.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
  <FormControl fullWidth >
    <InputLabel>Section</InputLabel>
    <Select
      name="Section"
      value={studentData.Section}
      onChange={handleInputChange}
    >
      <MenuItem value="">-- Select --</MenuItem>
      {sections.map((sec) => (
        <MenuItem key={sec.SectionID} value={sec.SectionID}>
          {sec.SectionName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

            <Grid item xs={12} sm={3}>
              <Button
                variant="outlined"
                fullWidth
                disabled={
                  !studentData.courseID ||
                  !studentData.academicYearID ||
                  !studentData.classID
                }
                onClick={() =>
                  (window.location.href = `${BASE_URL}/api/admission/template?courseID=${studentData.courseID}&academicYearID=${studentData.academicYearID}&classID=${studentData.classID}`)
                }
              >
                Download Template
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                component="label"
                disabled={
                  !studentData.courseID ||
                  !studentData.academicYearID ||
                  !studentData.classID
                }
              >
                Upload Filled Excel
                <input
                  hidden
                  type="file"
                  accept=".xlsx"
                  onChange={handleFileUpload}
                />
              </Button>
            </Grid>
          </Grid>
          {bulkResult && (
            <Box mt={2}>
              <Typography>
                Successfully admitted: {bulkResult.successCount}
              </Typography>
              <ul>
                {bulkResult.admitted.map((n, i) => (
                  <li key={i}>{n}</li>
                ))}
              </ul>
              {bulkResult.errors.length > 0 && (
                <>
                  <Typography color="error">Errors:</Typography>
                  <ul>
                    {bulkResult.errors.map((er, i) => (
                      <li key={i}>
                        Row {er.row}: {er.message}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </Box>
          )}
        </CardContent>
      </Card>
      {/* --- Single Admission Form --- */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          { key: "mandatory", label: "Mandatory Information" },
          { key: "personal", label: "Personal Information" },
          { key: "parent", label: "Parent Information" },
        ].map(({ key, label }) => (
          <Grid item key={key}>
            <Button
              variant={activeTab === key ? "contained" : "outlined"}
              onClick={() => setActiveTab(key)}
            >
              {label}
            </Button>
          </Grid>
        ))}
      </Grid>
      {activeTab === "mandatory" && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Student Name"
              fullWidth
              name="studentName"
              value={studentData.studentName}
              onChange={handleInputChange}
              error={!!errors.studentName}
              helperText={errors.studentName}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Mobile Number"
              fullWidth
              name="mobileNumber"
              value={studentData.mobileNumber}
              onChange={handleInputChange}
              error={!!errors.mobileNumber}
              helperText={errors.mobileNumber}
              inputProps={{ maxLength: 10 }}
              required
            />
          </Grid>
          {/* Course/Year/Class selectors same as above */}
        </Grid>
      )}
      {activeTab === "personal" && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Address"
              fullWidth
              name="address"
              value={studentData.address}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      )}
      {activeTab === "parent" && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Parent Name"
              fullWidth
              name="parentName"
              value={studentData.parentName}
              onChange={handleInputChange}
              error={!!errors.parentName}
              helperText={errors.parentName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Parent Contact"
              fullWidth
              name="parentContact"
              value={studentData.parentContact}
              onChange={handleInputChange}
              error={!!errors.parentContact}
              helperText={errors.parentContact}
            />
          </Grid>
        </Grid>
      )}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3 }}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Container>
  );
}
